var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlasses = function SvgGlasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 12s-.895-1-2-1-2 1-2 1M21 12h1M2 12h1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM17 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }))));
};
export default SvgGlasses;